import React from 'react';
import BlogCardClassic from '../../components/BlogElements/BlogCardClassic';
import Pagination from '../../components/common/Pagination';

const Blog2 = () => {
    const BlogData02 = [
        {
            id: '1',
            img: 'images/blog/md1.jpg',
            author: 'Dessert - By Zoyena Ross',
            title: 'Bread Jam Fusion',
        },
        {
            id: '2',
            img: 'images/blog/md2.jpg',
            author: 'Dessert - By Jacob Johnson',
            title: 'How to start food vlog',
        },
        {
            id: '3',
            img: 'images/blog/md3.jpg',
            author: 'Dessert - By Parker Noel',
            title: 'Fod serving art tips',
        },
        {
            id: '4',
            img: 'images/blog/md4.jpg',
            author: 'Dessert - By Austin Ryan',
            title: 'Misnighr Snack Bars',
        },
        {
            id: '5',
            img: 'images/blog/md5.jpg',
            author: 'Dessert - By Zoyena Ross',
            title: 'Bread Jam Fusion',
        },
        {
            id: '6',
            img: 'images/blog/md6.jpg',
            author: 'Dessert - By Jacob Johnson',
            title: 'How to start food vlog',
        },
    ];
    return (
        <div className="main-wrapper">
            <div className="container">

                <div className="blog_classic">
                    <div className="row">
                        {
                            BlogData02.map(data => <BlogCardClassic
                                key={data.id}
                                data={data}
                            />)
                        }
                    </div>
                </div>

                <Pagination />
            </div>
        </div>
    );
};

export default Blog2;